export { default } from './EmployeesBlock'
